import React, { Fragment } from 'react';
import { Helmet } from "react-helmet";
import LayoutDefault from "../../layouts/LayoutDefault";
import Header from "../../components/header/HeaderParagon";
import Breadcrumb from "../../components/breadcrumb/BreadcrumbTitleOnly";
import FooterParagon from "../../container/footer/FooterParagon"
import NewsComp from '../../components/news-from-be/NewsComp';

const NewsPage = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Paragon News</title>
            </Helmet>
            <LayoutDefault className="template-color-1 template-font-2">
                <Header />
                <Breadcrumb
                    title={"NEWS"}
                    bgImage={"bg-image-career"}
                />
                <NewsComp />
                <FooterParagon />
            </LayoutDefault>
        </Fragment>
    );
};

export default NewsPage;
